const _getTotal = (list, field, fixed = true) => {
  let numbers = list.map((x) => x[field]).filter((x) => x);
  let total = numbers.reduce((sum, item) => sum + parseFloat(item), 0);

  if (!fixed) return total;

  return total.toFixed(2);
};

export default {
  getTotal: _getTotal,
};
